<template>
  <div>
    <ContentWrapperControl>
      <div class="bg-white p-4 rounded-b-lg shadow overflow-hidden mb-4">
        <div
          v-text="lang('lbl_0000280')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>
      <div class="bg-white p-4 rounded-lg shadow">
        <div>
          <PinControl
            @typing="typing"
            @complete="complete"
            v-bind:value="pin"
            v-bind:label="lang('lbl_0000032')"
          />
        </div>
        <div class="px-4 pb-4">
          <div class="flex-1">
            <ButtonControl v-on:click="next" v-bind:disabled="disabled">
              {{ lang("lbl_0000033") }}
            </ButtonControl>
          </div>
        </div>
        <div class="pt-2 flex justify-center items-center pb-6">
          <div
            v-on:click="forgotPIN()"
            v-text="lang('lbl_0000286')"
            class="text-sm leading-none underline text-primary font-semibold"
          ></div>
        </div>
      </div>
    </ContentWrapperControl>
  </div>
</template>
<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import PinControl from "@/components/controls/PinControl.vue";
import User from "@/services/User.js";
import mixin from "./../mixin.js";
export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    PinControl,
  },
  mounted() {
    this.$emit("checkauth", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000281"),
      show: true,
      back: true,
      type: "logout",
    });
    this.$emit("nofooter", true);
  },
  data() {
    return {
      username: "",
      password: "",
      disabled: true,
      pin: null,
      name: null,
      email: null,
      mobile_no: null,
    };
  },
  methods: {
    complete(pin) {
      this.pin = pin;
    },
    typing(obj) {
      this.pin = obj;
      this.disabled = this.pin.length < 6;
    },
    next() {
      let state = this.$store.state;
      this.$emit("showloader");
      User.validatePin(state.uuid, this.pin)
        .then(() => {
          state.pin_login = true;
          this.makePINLoginCookie(state.hash);
          this.inputting_pin = false;
          state.enroll.pin = this.pin;

          if (!state.has_pin || (state.has_pin && state.pin_update)) {
            this.$router.push("/user/enroll/pin");
            this.$emit("hideloader");
            return;
          }

          if (
            state.config.find((item) => item.type === 2)?.status === true &&
            !state.otp_login
          ) {
            this.$router.push("/user/login/otp");
            return;
          }
          this.$emit("login");
          this.$emit("hideloader");
          this.$emit("nofooter", false);
          this.$router.push("/dashboard");
        })
        .catch((error) => {
          this.$emit("error", error);
          this.pin = "";
        });
    },
    forgotPIN() {
      this.$router.push("/user/reset/pin");
    },
  },
};
</script>
<style></style>
